import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PageComponent } from '@shared/components';
import { ContentPageId } from '@shared/models';
import { DAEnrollContent } from '@shared/services/content/content-jsons/open-choice/da-enroll.content';
import { OpenChoiceCommonContent } from '@shared/services/content/content-jsons/open-choice/open-choice-common.content';
import {
  Go,
  LogError,
  Next,
  rejectDAOffer,
  selectedAccountsFrom,
  State,
  TrackCallToAction,
  UpdateDAComponentFailure,
  UpdateDraftID,
  UpdateEnrollPageHTML,
} from '@store/index';
import { selectDAAccountsToEnroll } from '@store/selectors/open-choice/open-choice.selectors';

import { DraftInvestmentRecsLoadedEvent } from '../../../../../interfaces/open-choice/draft-investment.model';
import { ProjectionDetails } from '../../../../../interfaces/open-choice/projection-details.model';
import { getInnerHTML } from '../../../shared/helpers/get-inner-html';

const feeEstimationOpenModalEvent: { [key: string]: string } = {
  feeEstimationOpenModalDuringPromo: 'During Fee Waiver Info',
  feeEstimationOpenModalAfterPromo: 'After Fee Waiver Info',
};
@Component({
  selector: 'app-da-enroll',
  templateUrl: './da-enroll.component.html',
  styleUrl: './da-enroll.component.scss',
})
export class DAEnrollComponent extends PageComponent implements OnInit, OnDestroy {
  content = DAEnrollContent;
  commonContent = OpenChoiceCommonContent;
  DAOpenChoiceAccounts: ProjectionDetails | undefined;
  accountBalance: number | undefined;
  isMultipleAccountSelection: boolean | undefined;

  constructor(
    globalStore: Store<State>,
    private elementRef: ElementRef,
  ) {
    super(ContentPageId.daenroll, globalStore);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.subs.add(
      this.globalStore.pipe(select(selectDAAccountsToEnroll)).subscribe((accounts) => {
        this.DAOpenChoiceAccounts = accounts || undefined;
        this.isMultipleAccountSelection = (accounts?.placeholderAccounts.length ?? 0) > 1;
      }),
    );

    this.subs.add(
      this.globalStore.pipe(select(selectedAccountsFrom)).subscribe((fromAccounts) => {
        this.accountBalance = parseFloat(fromAccounts?.[0]?.accountData.balance || '0');
      }),
    );
  }

  daLoadDraftId(event: CustomEvent<DraftInvestmentRecsLoadedEvent>): void {
    const draftId: string = event?.detail?.draftId;
    this.globalStore.dispatch(UpdateDraftID({ payload: draftId }));
  }

  modalAnalyticsEventHandler(event: CustomEvent): void {
    const ctaName = feeEstimationOpenModalEvent[event.detail];
    if (ctaName) {
      this.globalStore.dispatch(
        TrackCallToAction({
          location: 'OC_DA_Offer_Page',
          ctaName,
          ctaType: 'Text Link',
        }),
      );
    }
  }

  errorHandler(errorEvent: CustomEvent): void {
    this.globalStore.dispatch(
      LogError({
        payload: {
          eventId: 'open-choice-da-enroll MFE error',
          errorEvent: JSON.stringify(errorEvent?.detail),
        },
      }),
    );
    this.globalStore.dispatch(rejectDAOffer());
    this.globalStore.dispatch(UpdateDAComponentFailure({ payload: true }));
    this.globalStore.dispatch(Go({ path: ['secure/minor-transfer/review'] }));
  }

  nextPage() {
    const pageHTML = getInnerHTML(this.elementRef.nativeElement);
    this.globalStore.dispatch(UpdateEnrollPageHTML({ payload: pageHTML }));
    this.globalStore.dispatch(Next());
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
